var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_core.js
// module id = 109
// module chunks = 48 49 50 51